'use client';

import { c as _c } from "react/compiler-runtime";
import { Disclosure, DisclosureButton, DisclosurePanel, Transition } from '@headlessui/react';
import { ChevronDownIcon } from '@heroicons/react/20/solid';
import { Fragment, type ReactNode } from 'react';
type MobileMenuDisclosureProps = {
  title: string;
  items: Array<{
    name: ReactNode;
    href: string;
  }>;
};
export function MobileMenuDisclosure(t0) {
  const $ = _c(3);
  const {
    title,
    items
  } = t0;
  let t1;
  if ($[0] !== items || $[1] !== title) {
    t1 = <Disclosure as="div" className="-mx-3">{t2 => {
        const {
          open
        } = t2;
        return <><DisclosureButton className="flex w-full items-center justify-between rounded-lg py-2 pr-3.5 pl-3 font-semibold text-base text-slate-900 leading-7 hover:bg-slate-50">{title}<ChevronDownIcon className={`${open ? "rotate-180" : ""} h-5 w-5 flex-none transition-transform duration-200`} aria-hidden="true" /></DisclosureButton><Transition as={Fragment} enter="transition ease-out duration-300" enterFrom="transform opacity-0 scale-95" enterTo="transform opacity-100 scale-100" leave="transition ease-in duration-200" leaveFrom="transform opacity-100 scale-100" leaveTo="transform opacity-0 scale-95"><DisclosurePanel>{t3 => {
                const {
                  close
                } = t3;
                return <div className="overflow-hidden transition-all duration-300 ease-in-out"><div className="mt-2 space-y-2 transition-all">{items.map(item => <a key={item.href} href={item.href} onClick={() => close()} className="block rounded-lg py-2 pr-3 pl-6 font-semibold text-slate-900 text-sm leading-7 hover:bg-slate-50">{item.name}</a>)}</div></div>;
              }}</DisclosurePanel></Transition></>;
      }}</Disclosure>;
    $[0] = items;
    $[1] = title;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}